import {
  AdSystemT,
  GooglePerformanceLabelT,
  useActiveImagesAssetLinesQuery,
  useActiveTextsAssetLinesQuery,
} from "../graphql/generated/graphql";

export const useHasLowPerformanceAssets = (adSystem: AdSystemT = AdSystemT.GoogleAdsT) => {
  const { data: dataActiveImageAssetLines } = useActiveImagesAssetLinesQuery({
    variables: { adSystem },
  });
  const { data: dataActiveTextAssetLines } = useActiveTextsAssetLinesQuery({
    variables: { adSystem },
  });

  const hasAnyLowPerformance =
    (dataActiveImageAssetLines?.organization?.activeImagesAssetLines || []).some(
      (line) => line.googlePerformanceLabel === GooglePerformanceLabelT.LowT
    ) ||
    (dataActiveTextAssetLines?.organization?.activeTextsAssetLines || []).some(
      (line) => line.googlePerformanceLabel === GooglePerformanceLabelT.LowT
    );

  return hasAnyLowPerformance;
};
